import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_EXPORTS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  EXPORT_DATA_GET_ROUTE_NAME,
  EXPORT_DATA_PERMISSIONS,
  TRANSLATION_GROUP_EXPORT_DATA,
} from './constants';
import { getTranslationKeys } from './translations';

export class ExportDataModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: EXPORT_DATA_GET_ROUTE_NAME,
      path: 'export-data',
      permission: EXPORT_DATA_PERMISSIONS.CREATE,
      component: () => import('./pages/ExportDataFormPage/ExportDataFormPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_EXPORTS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'ADMIN_EXPORT_EXPORT_DATA'),
      to: {
        name: EXPORT_DATA_GET_ROUTE_NAME,
      },
      permission: EXPORT_DATA_PERMISSIONS.CREATE,
      id: EXPORT_DATA_GET_ROUTE_NAME,
      order: 10,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_EXPORT_DATA, getTranslationKeys);
  }
}
